/**
 * Signup funnel events. Keep this set small — completed onboarding, set rules,
 * started connecting a broker. Do not add per-step "viewed" events here.
 */
export const SIGNUP_FUNNEL_EVENTS = {
  ONBOARDING_COMPLETED: 'onboarding_completed',
  TRADING_RULES_SET: 'trading_rules_set',
  STARTED_CONNECT_BROKER: 'started_connect_broker',
};

export const SIGNUP_FUNNEL_EVENT_LIST = [
  SIGNUP_FUNNEL_EVENTS.ONBOARDING_COMPLETED,
  SIGNUP_FUNNEL_EVENTS.TRADING_RULES_SET,
  SIGNUP_FUNNEL_EVENTS.STARTED_CONNECT_BROKER,
];

export function startedConnectBrokerProps({ broker, via, userId } = {}) {
  const name = String(broker || '').trim() || 'Broker';
  return {
    ...(userId != null ? { user_id: userId } : {}),
    broker: name,
    ...(via ? { via } : {}),
  };
}
